import { useBusinessProfile } from '#client/hooks/useBusinessProfile';

import BusinessProfile from './BusinessProfile';
import BusinessProfileSkeleton from './BusinessProfileSkeleton';

function BusinessProfileWrapper() {
  const { data, loading } = useBusinessProfile();

  if (loading) {
    return <BusinessProfileSkeleton />;
  }

  const { registeredAgents, businessEntity } = data || {};

  return <BusinessProfile registeredAgents={registeredAgents} businessEntity={businessEntity} />;
}

export default BusinessProfileWrapper;
